// frontend/src/pages/Socrates/components/common/LoadingSpinner/index.js

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import styles from './LoadingSpinner.module.css';

const LoadingSpinner = ({ 
  size = 'medium', // 'small', 'medium', 'large'
  message = '',
  variant = 'default', // 'default', 'overlay'
  className = ''
}) => {
  const spinnerClasses = [
    styles.spinner,
    styles[size],
    styles[variant],
    className
  ].filter(Boolean).join(' ');

  if (variant === 'overlay') {
    return (
      <div className={styles.overlay}>
        <div className={styles.overlayContent}>
          <FontAwesomeIcon icon={faSpinner} className={spinnerClasses} spin />
          {message && <p className={styles.message}>{message}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <FontAwesomeIcon icon={faSpinner} className={spinnerClasses} spin />
      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default LoadingSpinner;